import _asyncToGenerator from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _regeneratorRuntime from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import Datalayer from './data/Datalayer';

var Analytics = /*#__PURE__*/function () {
  function Analytics() {
    var _this = this;

    _classCallCheck(this, Analytics);

    _defineProperty(this, "providers", []);

    _defineProperty(this, "eventsQueue", []);

    _defineProperty(this, "isInitialized", false);

    _defineProperty(this, "isPrepared", false);

    _defineProperty(this, "initialize", function () {
      var _iterator = _createForOfIteratorHelper(_this.providers),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var provider = _step.value;
          provider.init();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      _this.isInitialized = true;

      if (_this.eventsQueue.length) {
        _this.eventsQueue.forEach(function (_ref) {
          var data = _ref.data,
              providers = _ref.providers;

          _this.sendEvent(data, providers);
        });

        _this.eventsQueue = [];
      }
    });
  }

  _createClass(Analytics, [{
    key: "prepare",
    value:
    /**
     * Creates a list with all the providers that will be used for analytics,
     * used before loading the providers
     */
    function prepare(providers) {
      var _iterator2 = _createForOfIteratorHelper(providers),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var provider = _step2.value;
          this.providers.push(provider);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      this.isPrepared = true;
    }
    /**
     * @deprecated Instead of this use sendCustomEvent (Which doesnt require to setup DLV in GTM)
     */

  }, {
    key: "sendEvent",
    value: function () {
      var _sendEvent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(data, providers) {
        var collection, _iterator3, _step3, provider, _iterator4, _step4, pr;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.isInitialized) {
                  _context.next = 3;
                  break;
                }

                this.eventsQueue.push({
                  data: data,
                  providers: providers
                });
                return _context.abrupt("return");

              case 3:
                collection = [];
                _iterator3 = _createForOfIteratorHelper(this.providers);

                try {
                  for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                    provider = _step3.value;

                    if (!providers) {
                      if (provider.isActive) {
                        collection.push(provider.sendEvent(data));
                      }
                    } else {
                      _iterator4 = _createForOfIteratorHelper(providers);

                      try {
                        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                          pr = _step4.value;

                          if (pr.name === provider.constructor.name) {
                            collection.push(provider.sendEvent(data));
                          }
                        }
                      } catch (err) {
                        _iterator4.e(err);
                      } finally {
                        _iterator4.f();
                      }
                    }
                  }
                } catch (err) {
                  _iterator3.e(err);
                } finally {
                  _iterator3.f();
                }

                return _context.abrupt("return", Promise.all(collection));

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function sendEvent(_x, _x2) {
        return _sendEvent.apply(this, arguments);
      }

      return sendEvent;
    }()
  }, {
    key: "sendCustomEvent",
    value: function () {
      var _sendCustomEvent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(analyticEventName, data) {
        var genericEventName, dlvGenericEventName, datalayerObject;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                genericEventName = 'generic_analytics_event';
                dlvGenericEventName = 'generic_analytics_event_data';
                datalayerObject = new Datalayer(genericEventName, _defineProperty({}, dlvGenericEventName, JSON.stringify({
                  analyticEventName: analyticEventName,
                  data: data
                })));
                return _context2.abrupt("return", this.sendEvent(datalayerObject));

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function sendCustomEvent(_x3, _x4) {
        return _sendCustomEvent.apply(this, arguments);
      }

      return sendCustomEvent;
    }()
  }]);

  return Analytics;
}();

export { Analytics as default };